/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { GetNotificationsRequestDto } from '../models';
// @ts-ignore
import type { MarkNotificationAsSeenRequestDto } from '../models';
// @ts-ignore
import type { NotificationsPageResponseDto } from '../models';
/**
 * RestNotificationControllerApi - axios parameter creator
 * @export
 */
export const RestNotificationControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get notifications
         * @param {GetNotificationsRequestDto} getNotificationsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotifications: async (getNotificationsRequestDto: GetNotificationsRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'getNotificationsRequestDto' is not null or undefined
            assertParamExists('getNotifications', 'getNotificationsRequestDto', getNotificationsRequestDto)
            const localVarPath = `/api/v2/notifications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getNotificationsRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Mark notification as not seen
         * @param {number} notificationId 
         * @param {MarkNotificationAsSeenRequestDto} markNotificationAsSeenRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markNotificationAsNotSeen: async (notificationId: number, markNotificationAsSeenRequestDto: MarkNotificationAsSeenRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'notificationId' is not null or undefined
            assertParamExists('markNotificationAsNotSeen', 'notificationId', notificationId)
            // verify required parameter 'markNotificationAsSeenRequestDto' is not null or undefined
            assertParamExists('markNotificationAsNotSeen', 'markNotificationAsSeenRequestDto', markNotificationAsSeenRequestDto)
            const localVarPath = `/api/v2/notifications/{notificationId}/not-seen`
                .replace(`{${"notificationId"}}`, encodeURIComponent(String(notificationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(markNotificationAsSeenRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Mark notification as seen
         * @param {number} notificationId 
         * @param {MarkNotificationAsSeenRequestDto} markNotificationAsSeenRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markNotificationAsSeen: async (notificationId: number, markNotificationAsSeenRequestDto: MarkNotificationAsSeenRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'notificationId' is not null or undefined
            assertParamExists('markNotificationAsSeen', 'notificationId', notificationId)
            // verify required parameter 'markNotificationAsSeenRequestDto' is not null or undefined
            assertParamExists('markNotificationAsSeen', 'markNotificationAsSeenRequestDto', markNotificationAsSeenRequestDto)
            const localVarPath = `/api/v2/notifications/{notificationId}/seen`
                .replace(`{${"notificationId"}}`, encodeURIComponent(String(notificationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(markNotificationAsSeenRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RestNotificationControllerApi - functional programming interface
 * @export
 */
export const RestNotificationControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RestNotificationControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get notifications
         * @param {GetNotificationsRequestDto} getNotificationsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNotifications(getNotificationsRequestDto: GetNotificationsRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotificationsPageResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNotifications(getNotificationsRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestNotificationControllerApi.getNotifications']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Mark notification as not seen
         * @param {number} notificationId 
         * @param {MarkNotificationAsSeenRequestDto} markNotificationAsSeenRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async markNotificationAsNotSeen(notificationId: number, markNotificationAsSeenRequestDto: MarkNotificationAsSeenRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.markNotificationAsNotSeen(notificationId, markNotificationAsSeenRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestNotificationControllerApi.markNotificationAsNotSeen']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Mark notification as seen
         * @param {number} notificationId 
         * @param {MarkNotificationAsSeenRequestDto} markNotificationAsSeenRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async markNotificationAsSeen(notificationId: number, markNotificationAsSeenRequestDto: MarkNotificationAsSeenRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.markNotificationAsSeen(notificationId, markNotificationAsSeenRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestNotificationControllerApi.markNotificationAsSeen']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RestNotificationControllerApi - factory interface
 * @export
 */
export const RestNotificationControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RestNotificationControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary Get notifications
         * @param {GetNotificationsRequestDto} getNotificationsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotifications(getNotificationsRequestDto: GetNotificationsRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<NotificationsPageResponseDto> {
            return localVarFp.getNotifications(getNotificationsRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Mark notification as not seen
         * @param {number} notificationId 
         * @param {MarkNotificationAsSeenRequestDto} markNotificationAsSeenRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markNotificationAsNotSeen(notificationId: number, markNotificationAsSeenRequestDto: MarkNotificationAsSeenRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.markNotificationAsNotSeen(notificationId, markNotificationAsSeenRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Mark notification as seen
         * @param {number} notificationId 
         * @param {MarkNotificationAsSeenRequestDto} markNotificationAsSeenRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markNotificationAsSeen(notificationId: number, markNotificationAsSeenRequestDto: MarkNotificationAsSeenRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.markNotificationAsSeen(notificationId, markNotificationAsSeenRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RestNotificationControllerApi - interface
 * @export
 * @interface RestNotificationControllerApi
 */
export interface RestNotificationControllerApiInterface {
    /**
     * 
     * @summary Get notifications
     * @param {GetNotificationsRequestDto} getNotificationsRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestNotificationControllerApiInterface
     */
    getNotifications(getNotificationsRequestDto: GetNotificationsRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<NotificationsPageResponseDto>;

    /**
     * 
     * @summary Mark notification as not seen
     * @param {number} notificationId 
     * @param {MarkNotificationAsSeenRequestDto} markNotificationAsSeenRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestNotificationControllerApiInterface
     */
    markNotificationAsNotSeen(notificationId: number, markNotificationAsSeenRequestDto: MarkNotificationAsSeenRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Mark notification as seen
     * @param {number} notificationId 
     * @param {MarkNotificationAsSeenRequestDto} markNotificationAsSeenRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestNotificationControllerApiInterface
     */
    markNotificationAsSeen(notificationId: number, markNotificationAsSeenRequestDto: MarkNotificationAsSeenRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * RestNotificationControllerApi - object-oriented interface
 * @export
 * @class RestNotificationControllerApi
 * @extends {BaseAPI}
 */
export class RestNotificationControllerApi extends BaseAPI implements RestNotificationControllerApiInterface {
    /**
     * 
     * @summary Get notifications
     * @param {GetNotificationsRequestDto} getNotificationsRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestNotificationControllerApi
     */
    public getNotifications(getNotificationsRequestDto: GetNotificationsRequestDto, options?: RawAxiosRequestConfig) {
        return RestNotificationControllerApiFp(this.configuration).getNotifications(getNotificationsRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Mark notification as not seen
     * @param {number} notificationId 
     * @param {MarkNotificationAsSeenRequestDto} markNotificationAsSeenRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestNotificationControllerApi
     */
    public markNotificationAsNotSeen(notificationId: number, markNotificationAsSeenRequestDto: MarkNotificationAsSeenRequestDto, options?: RawAxiosRequestConfig) {
        return RestNotificationControllerApiFp(this.configuration).markNotificationAsNotSeen(notificationId, markNotificationAsSeenRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Mark notification as seen
     * @param {number} notificationId 
     * @param {MarkNotificationAsSeenRequestDto} markNotificationAsSeenRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestNotificationControllerApi
     */
    public markNotificationAsSeen(notificationId: number, markNotificationAsSeenRequestDto: MarkNotificationAsSeenRequestDto, options?: RawAxiosRequestConfig) {
        return RestNotificationControllerApiFp(this.configuration).markNotificationAsSeen(notificationId, markNotificationAsSeenRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}

